import { render, staticRenderFns } from "./BubuiaAudio.vue?vue&type=template&id=01d20e72&scoped=true&"
import script from "./BubuiaAudio.vue?vue&type=script&lang=js&"
export * from "./BubuiaAudio.vue?vue&type=script&lang=js&"
import style0 from "./BubuiaAudio.vue?vue&type=style&index=0&id=01d20e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d20e72",
  null
  
)

export default component.exports